import _ from 'lodash';
import authentication from '@feathersjs/authentication';
import jwtAuth from '@feathersjs/authentication-jwt';
import localAuth from '@feathersjs/authentication-local';
import stationAuth from './station-auth';
// import localhostAuth from './localhost-auth';
import { authenticate } from '../../hooks';

export default function configureAuth( app ) {
  const config = app.config.get( 'authentication' );
  _.defaultsDeep( config, {
    path    : '/api/authentication',
    entity  : 'member',
    service : '/api/members',
    jwt     : { audience : 'swiper', subject : 'access', issuer : 'swiper' },
  } );

  // Set up authentication with the secret
  app.configure( authentication( config ) );
  // app.configure( localhostAuth() );
  app.configure( stationAuth() );
  app.configure( localAuth() );
  app.configure( jwtAuth() );

  const strategies = [ 'jwt', 'station', 'local' ];
  /*
  // eslint-disable-next-line no-process-env
  if ( process.env.NODE_ENV !== 'production' ) {
    strategies.push( 'localhost' );
  }
  */
  app.service( '/api/authentication' ).hooks( {
    before  : {
      create  : [ authenticate( strategies ) ],
      remove  : [ authenticate( 'jwt' ) ],
    },
  } );
}
